import { formatTiles, formatRichText, formatCTAS, filterConfigs } from "../../functions";
import { VariantTitle } from "../../components/VariantTitle";
import { TILE_DISPLAY_VARIANTS, CONFIGURATION_TYPE_IDS } from "../../constants";
import { CTAWrapper } from "../../components/CTA/CTAWrapper";
import { PageSectionWrapper } from "../../components/PageSectionWrapper";
import { ListTile, ListTileEmbedded, NumberedTile, BorderedIconTile, IconTile, ImageTile} from "../../components/Tiles";

import { Button } from "semantic-ui-react";
import SIcon from "@iscr/views/NUI/StreamlineIcons/SIcon";
import { Link } from "react-router";

const TILE_DISPLAY_COMPONENT_MAP = {
	[TILE_DISPLAY_VARIANTS.ICON_TILE]: IconTile,
	[TILE_DISPLAY_VARIANTS.BORDERED_ICON_TILE]: BorderedIconTile,
	[TILE_DISPLAY_VARIANTS.LIST]: ListTile,
	[TILE_DISPLAY_VARIANTS.IMAGE_TILE]: ImageTile,
	[TILE_DISPLAY_VARIANTS.NUMBERED_TILES]: NumberedTile,
};

const TILE_DISPLAY_EMBEDDED_COMPONENT_MAP = {
	[TILE_DISPLAY_VARIANTS.LIST]: ListTileEmbedded,
};

export const TileListContent = ({
	headerText,
	subtitle,
	description,
	tiles,
	variant,
	tileDisplayVariant,
	siteStatus,
	ctas,
	isStatic = false,
	isVertical = false,
	isEmbedded = false,
	formattedSectionStyles,
	configurations = [],
	parsedFunctions = {},
	footnote
}) => {
	const formattedTiles = formatTiles(tiles, tileDisplayVariant);
	const formattedCTAS = formatCTAS(ctas, siteStatus, isStatic);
	const formattedDescription = formatRichText(description, siteStatus, configurations, parsedFunctions, isStatic);
	const formattedFootnote = formatRichText(footnote, siteStatus, configurations, parsedFunctions, isStatic);
	const componentMap = isEmbedded ? { ...TILE_DISPLAY_COMPONENT_MAP, ...TILE_DISPLAY_EMBEDDED_COMPONENT_MAP } : TILE_DISPLAY_COMPONENT_MAP;
	const TileDisplayComponent = componentMap[tileDisplayVariant];
	const tileListConfig = filterConfigs(configurations, CONFIGURATION_TYPE_IDS.TILE_LIST);
	if (!TileDisplayComponent) {
		console.warn(`Tile display variant ${tileDisplayVariant} is not supported`);
		return null;
	}

	const descriptionConfiguration = filterConfigs(configurations, CONFIGURATION_TYPE_IDS.RICH_TEXT)?.[0];
	const row = descriptionConfiguration?.displayRow;

	return (
		<>
			{headerText && (
				<VariantTitle
					title={headerText}
					subtitle={subtitle}
					parsedClasses={formattedSectionStyles.headerStyling}
				/>
			)}

			<div className={`${row && "flex flex-col md:flex-row flex-col-reverse gap-8"}`}>

				{(row && formattedDescription) && <div className={`p-8 rounded flex flex-col gap-8 text-center w-full md:w-1/2 bg-white [&_button]:!text-is2-blue [&_h4]:!mb-0 [&_p]:!mb-0`}>{formattedDescription}</div>}

				<div>
					<TileDisplayComponent
						tiles={formattedTiles}
						variant={variant}
						formattedSectionStyles={formattedSectionStyles}
						isVertical={isVertical}
						columnCount={tileListConfig[0]?.columnCount}
						iconSize={tileListConfig[0]?.iconSize}
						iconTextGap={tileListConfig[0]?.iconTextGap}
						width={row && "w-1/2 min-w-[101px]"}
					/>
					{(formattedDescription || formattedFootnote) && (
						<div
							className={`w-2/3 ${formattedSectionStyles.textColor} text-sm mt-4 m-auto ${formattedSectionStyles.descriptionStyling} ${descriptionConfiguration?.wrapperStyling}`}
						>

							{!row && formattedDescription}
							{formattedFootnote}
						</div>
					)}
					
				</div>
			</div>

			{formattedCTAS?.length ? (
				<div className="flex flex-col w-full md:w-1/2 md:flex-row gap-4 mt-[52px] justify-center m-auto ">
					{formattedCTAS.map((cta, index) => (
						<CTAWrapper key={index} cta={cta} parsedFunctions={parsedFunctions} />
					))}
				</div>
			) : null}
		</>
	);
};

export const TileListPageSection = (props) => {
	const pageSectionClasses =
		props.tileDisplayVariant === TILE_DISPLAY_VARIANTS.LIST ? "pt-0 mt-[-64px] lg:pt-0 w-full" : "w-full";

	return (
		<PageSectionWrapper variant={props.variant} parsedClasses={pageSectionClasses}>
			<TileListContent {...props} />
		</PageSectionWrapper>
	);
};
